/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type unit_option_magic_item_category_full = {
  id: number;
  version_id: number;
  name: string | null;
  is_multiple: boolean;
  max: number;
  ratio: number;
  ratio_action: unit_option_magic_item_category_full.ratio_action;
  min_by_model: number;
  max_by_model: number | null;
};
export namespace unit_option_magic_item_category_full {
  export enum ratio_action {
    MULTIPLIER = 'multiplier',
    DECREASING = 'decreasing',
  }
}
